import { ButtonV2 } from '@cimplico/components';
import { useState } from 'react';
import { ReactComponent as Logo } from '../../../../assets/workpapers-logo-indigo.svg';
import OnboardingStep from '../../OnboardingStep';
type WelcomeVideoProps = {
    onNext: () => void;
};

function WelcomeVideo({ onNext }: WelcomeVideoProps): JSX.Element {
    return (
        <OnboardingStep>
            <div className="flex flex-col mx-auto max-w-[600px]">
                <Logo className="mx-auto" />
                <h1 className="text-contentPrimary text-3xl font-bold my-2 text-center">Welcome to Cimplico Workpapers!</h1>
                <p className="text-contentSecondary text-sm font-medium text-center">Get up and running in a few minutes.</p>
                <Video />
                <ButtonV2 label="Finish up" size="sm" onClick={onNext} />
            </div>{' '}
        </OnboardingStep>
    );
}

function Video(): JSX.Element {
    const [loading, setLoading] = useState(true);
    return (
        <div className="h-[375px] w-full my-8 relative">
            {loading && <div className="bg-gray-50 h-full w-full absolute"></div>}
            <iframe
                src="https://player.vimeo.com/video/1053669575?h=e868ef3874&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                className="h-full w-full"
                title="Cimplico Workpapers Demo"
                onLoad={(): void => setLoading(false)}
            ></iframe>
        </div>
    );
}

export default WelcomeVideo;
